import { logoutApi } from '@/common/api';
import request from '@/utils/request';
import { setToken, getToken, removeToken } from '@/utils/Token';
import { defineStore } from 'pinia';
export const useUserStore = defineStore('user-store', {
  state: () => ({
    _info: {
      id: 0,
      account: "",
      nickname: "",
      avatar_url: "",
      created_at: "",
      updated_at: ""
    },
    _token: "",
  }),
  actions: {
    initUser() {
      const token = getToken();
      this._token = token;
      if (token) {
        this.getUserInfo();
      } else {
        removeToken();
      }
    },
    setToken(token) {
      this._token = token;
      setToken(this._token);
    },
    getUserInfo() {
      request.get("/client/account/info").then(info => {
        this.setUserInfo(info);
      })
    },
    setUserInfo(info) {
      Object.assign(this._info, info);
    },
    async logout() {
      try {
        await logoutApi();
      } catch (error) {
        console.log(error);
      }
      removeToken();
      this._token = "";
      this._info = {
        id: 0,
        account: "",
        nickname: "",
        avatar_url: "",
        created_at: "",
        updated_at: ""
      };
    },
  },
  getters: {
    info: (state) => state._info,
    token: (state) => state._token,
  },
});
